(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@unicorns/howzit-vue", [], factory);
	else if(typeof exports === 'object')
		exports["@unicorns/howzit-vue"] = factory();
	else
		root["@unicorns/howzit-vue"] = factory();
})(window, function() {
return 